import {
  Shield, BookMarked, Sparkles, FileSearch, FolderTree,
  HardHat, ShoppingCart, ListChecks, BadgeDollarSign, Settings2, ScrollText, Award,
  Receipt, Gavel, Users2, Megaphone, ShieldAlert, CalendarDays, Video,
  Network, Scale,
  Briefcase, BookOpen, ShieldCheck, LayoutDashboard,
  Activity, UsersRound,
  History as HistoryIcon,
  Building2, LifeBuoy, Mail, Clock, Landmark, CalendarClock, FileSignature,
  AlarmClock, TrendingUp, MessagesSquare, CreditCard, Wallet,
} from "lucide-react";

// Iter 96 · Reorganización en 6 categorías. Cada módulo conserva su key,
// route, color, icono y componente original — sólo se añade `category`.
// El Dashboard agrupa por estas categorías; los enlaces antiguos siguen
// funcionando gracias a las redirecciones declaradas en App.js.

export const CATEGORIES = [
  {
    key: "correo",
    label: "Comunicaciones",
    color: "#DC2626",
    Icon: Mail,
    desc: "Bandeja IMAP + IA · plazos legales · expedientes jurídicos · DEHú",
    pinned: true,
  },
  {
    key: "comercial",
    label: "Licitaciones",
    color: "#6D43B8",
    Icon: Briefcase,
    desc: "Capta, analiza y automatiza ofertas y pliegos",
  },
  {
    key: "comercial_dept",
    label: "Comercial",
    color: "#0E9488",
    Icon: Briefcase,
    desc: "Cartera comercial · obras adjudicadas · equipo y métricas",
  },
  {
    key: "obra",
    label: "Obra / Producción",
    color: "#E08A1F",
    Icon: HardHat,
    desc: "Planifica, ejecuta y documenta la obra día a día",
  },
  {
    key: "adquisiciones",
    label: "Compras y Subcontratación",
    color: "#7C3AED",
    Icon: ShoppingCart,
    desc: "Pedidos, contratos y libro de subcontratación",
  },
  {
    key: "financiero",
    label: "Económico-Financiero",
    color: "#127372",
    Icon: Receipt,
    desc: "Facturación, bancos, fiscal y tesorería",
  },
  {
    key: "avales",
    label: "Garantías",
    color: "#0F8A5F",
    Icon: ShieldCheck,
    desc: "Avales bancarios en vigor y Fianzas por transferencia",
  },
  {
    key: "juridico",
    label: "Legal",
    color: "#7C3AED",
    Icon: Shield,
    desc: "Notificaciones electrónicas · expedientes · plazos · certificados",
  },
  // WA0224 · Fase A · Fusión "Personas y Prevención" + "Transversal/Soporte" → "Personas y Soporte"
  {
    key: "personas",
    label: "Personas y Soporte",
    color: "#1E5BCC",
    Icon: UsersRound,
    desc: "RRHH, procedimientos, comunicación, administración y soporte transversal",
  },
  // WA0224 · categoría "transversal" retirada; sus módulos migran a "personas".
  {
    key: "mis_cosas",
    label: "Mi Espacio",
    color: "#6D43B8",
    Icon: LifeBuoy,
    desc: "Mis documentos, procedimientos y notificaciones personales",
  },
];

export const findCategory = (key) => CATEGORIES.find((c) => c.key === key);

export const MODULES = [
  // ───── 1. Licitaciones ─────
  {
    key: "licitaciones",
    title: "Licitaciones",
    description: "Buscador PLACSP en tiempo real · 86.000+ licitaciones · IA pliegos y anexos · CRM · calendario · firma PAdES",
    color: "#6D43B8",
    route: "/licitaciones",
    Icon: Gavel,
    category: "comercial",
    span: "md:col-span-2 md:row-span-1",
  },
  {
    key: "documentacion_empresa",
    title: "Documentación de Empresa",
    description: "Carpeta central · NIF, escrituras, ISOs, pólizas, solvencia · Auto-completa checklists",
    color: "#1E5BCC",
    route: "/documentacion-empresa",
    Icon: Building2,
    category: "comercial",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "tasas_urbanisticas",
    title: "Tasas urbanísticas",
    description: "Auto-creadas al adjudicar autonómicas/locales · Asignadas al responsable · Justificantes",
    color: "#E08A1F",
    route: "/tasas-urbanisticas",
    Icon: Receipt,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "comercial_dept",
    title: "Comercial",
    description: "Equipo comercial · obras adjudicadas · pipeline · objetivos",
    color: "#0E9488",
    route: "/comercial",
    Icon: Briefcase,
    category: "comercial_dept",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "juridico",
    title: "Jurídico (movido a LEGAL)",
    description: "Esta entrada se ha unificado en el módulo LEGAL.",
    color: "#7C3AED",
    route: "/legal",
    Icon: Shield,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
    deprecated: true,
  },

  // ───── 2. Obra / Producción ─────
  {
    key: "obra",
    title: "Gestión de Obra",
    description: "Actas, dashboard por obra, hitos y subcontratas · BC3",
    color: "#E08A1F",
    route: "/obras",
    Icon: HardHat,
    category: "obra",
    span: "md:col-span-2 md:row-span-1",
  },
  {
    key: "analisis",
    title: "Revisión de Proyecto",
    description: "Checklist 14 bloques · 90 puntos · informe IA a DF · precios contradictorios",
    color: "#D85A1F",
    route: "/analisis",
    Icon: FileSearch,
    category: "_hidden",  // WA0229 · Integrado dentro de cada obra (ObraDashboard)
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "documental_obra",
    title: "Documental de Obra",
    description: "PSS, Gantt con certificaciones y documentación PRL",
    color: "#0D6E8C",
    route: "/documental-obra",
    Icon: FolderTree,
    category: "_hidden",
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "bitacora",
    title: "Bitácora oficial",
    description: "Trazabilidad cronológica de todo lo firmado y archivado · auditoría e inspecciones",
    color: "#127372",
    route: "/bitacora",
    Icon: Activity,
    category: "_hidden",  // WA0229 · Reemplazada por log de auditoría por usuario dentro de cada obra
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },

  // ───── 3. Proveedores (WA0169 · unificado: distribuidores + subcontratas) ─────
  {
    key: "adquisiciones",
    title: "Proveedores",
    description: "Distribuidores de material + Subcontratas de mano de obra · homologación, REA, CAE, contratos",
    color: "#7C3AED",
    route: "/proveedores",
    Icon: ShoppingCart,
    category: "adquisiciones",
    span: "md:col-span-1 md:row-span-1",
  },

  // ───── 4. Económico-Financiero ─────
  {
    key: "facturacion",
    title: "Facturación y Contabilidad",
    description: "Facturas emitidas y recibidas, vencimientos, ISP",
    color: "#127372",
    route: "/facturacion",
    Icon: Receipt,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "bancos",
    title: "Bancos y Conciliación",
    description: "Extractos bancarios (CSV/Excel/Norma 43), matching automático de cobros y pagos",
    color: "#0E7490",
    route: "/bancos",
    Icon: Landmark,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "fiscal_sl",
    title: "Fiscal SL · España 2026",
    description: "Calendario fiscal, IVA (303), IS (200), modelo 347 y compliance para Sociedades Limitadas. Tipos vigentes 2026.",
    color: "#6D43B8",
    route: "/fiscal-sl",
    Icon: Receipt,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "contabilidad_libro_diario",
    title: "Libro Diario · Modelo 303",
    description: "Asientos contables auto-generados (concilar banco + validar factura OCR) · Modelo 303 IVA trimestral · Export CSV SII AEAT.",
    color: "#7E22CE",
    route: "/contabilidad/libro-diario",
    Icon: BookOpen,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "contabilidad_fiscal_360",
    title: "Fiscal 360º",
    description: "IVA trimestral · Previsión Impuesto Sociedades · Calendario de vencimientos AEAT (303/111/202/200/347) con alertas.",
    color: "#B43A4E",
    route: "/contabilidad/fiscal-360",
    Icon: CalendarClock,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "avales_garantias",
    title: "Garantías",
    description: "Avales bancarios en vigor y Fianzas por transferencia",
    color: "#0F8A5F",
    route: "/avales-garantias",
    Icon: Shield,
    category: "avales",
    span: "md:col-span-1 md:row-span-1",
  },

  // ───── 5. Personas y Prevención ─────
  {
    key: "rrhh",
    title: "RRHH — Recursos Humanos",
    description: "Plantilla, contratos firmados, fichaje RD 8/2019, control horario con geolocalización, vencimientos PRL/TPC y partes de trabajo con integración a Facturación",
    color: "#7C3AED",
    route: "/rrhh",
    Icon: UsersRound,
    category: "personas",
    span: "md:col-span-2 md:row-span-1",
  },
  {
    key: "pss",
    title: "PSS — Seguridad y Salud",
    description: "Estudios y Planes de Seguridad y Salud (RD 1627/1997) con wizard de 9 pasos, biblioteca de riesgos y export PDF/RTF/BC3",
    color: "#B43A4E",
    route: "/pss",
    Icon: ShieldCheck,
    // WA0208 · PSS unificado en la ficha de Gestión de Obra. Se oculta la baldosa
    // del dashboard "Personas y Prevención" para eliminar el módulo duplicado.
    // Las rutas /pss y /pss/:id siguen accesibles para enlaces internos.
    category: "_hidden",
    hidden: true,
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "cae",
    title: "CAE — Alertas globales",
    description: "Coordinación de actividades, docs PRL y reconocimientos al día",
    color: "#7E22CE",
    route: "/cae",
    Icon: ShieldAlert,
    // WA0213 · CAE unificado en la ficha de Gestión de Obra (subcontratas ya lo tienen).
    // Ocultamos la baldosa dashboard "Personas y Prevención" para evitar duplicidad.
    // Ruta /cae sigue accesible para enlaces internos.
    category: "_hidden",
    hidden: true,
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },

  // ───── 6. Transversal / Soporte ─────
  {
    key: "kanban_global",
    title: "Kanban & Calendario",
    description: "Vista transversal Kanban + Calendario · Obras, Comercial, Licitaciones, Compras, PSS, Financiero, RRHH",
    color: "#1E5BCC",
    route: "/kanban-global",
    Icon: ListChecks,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "legal",
    title: "Legal",
    description: "Notificaciones electrónicas AAPP/LexNET + expedientes jurídicos + plazos + Certificado DEHú · IA extrae expediente desde PDF",
    color: "#B43A4E",
    route: "/legal",
    Icon: Scale,
    category: "juridico",
    span: "md:col-span-2 md:row-span-1",
  },
  {
    key: "facturas_recibidas",
    title: "Facturas Recibidas",
    description: "Bandeja de facturas de proveedor con conformidad automática: contrato vinculado, certificación DF aprobada e importe dentro de lo pendiente",
    color: "#1E5BCC",
    route: "/facturas-recibidas",
    Icon: Receipt,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "firmas_docs",
    title: "Firmas de Documentos",
    description: "Envío a firma online de cualquier PDF (contratos, actas, pedidos, cartas) con enlace seguro, recordatorios automáticos y certificado de evidencias",
    color: "#0F8A5F",
    route: "/firmas",
    Icon: FileSignature,
    category: "juridico",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "dehu_buzon",
    title: "Notificaciones Administrativas · DEHú",
    description: "Notificaciones de ~9.000 administraciones por filial · recogida automática en segundo plano · respuesta por sede electrónica · reglas de sede",
    color: "#C28A2A",
    route: "/dehu",
    Icon: Landmark,
    category: "juridico",
    span: "md:col-span-1 md:row-span-1",
  },
  // WA0221 · retirado del menú: "Biblioteca Documental" (repositorio parcial).
  // Los archivos se consultan directamente desde cada obra.
  // WA0243 · "SOP — Procedimientos (legado)" ELIMINADO por petición del usuario
  // (la ruta /sop redirige a /procedimientos; funcionalidad absorbida por Procedimientos SOP).
  {
    key: "procedimientos",
    title: "Procedimientos (SOP)",
    description: "Procedimientos vinculantes con IA, versionado, firma y KPIs",
    color: "#6D43B8",
    route: "/procedimientos",
    Icon: ListChecks,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
    hidden: true, // WA0242 · movido a Administración → pestaña SOP (ruta directa sigue activa)
  },
  {
    key: "mis_procedimientos",
    title: "Mis Procedimientos",
    description: "Procedimientos pendientes de leer y firmar",
    color: "#1E5BCC",
    route: "/mis-procedimientos",
    Icon: ListChecks,
    category: "mis_cosas",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "mis_tareas_workflow",
    title: "Mis Tareas (Workflow)",
    description: "Tareas operativas mensuales (certificaciones, etc.)",
    color: "#6D43B8",
    route: "/mis-tareas-workflow",
    Icon: ListChecks,
    category: "mis_cosas",
    span: "md:col-span-1 md:row-span-1",
  },
  // WA0221 · retirado del menú: "Cumplimiento Workflow" (confusión con Seguridad y Salud).
  // Los KPIs de cumplimiento se replantearán como pestaña dentro de Procedimientos.
  {
    key: "notificaciones_legacy",
    title: "Notificaciones AAPP (movido a LEGAL)",
    description: "Bandeja IMAP + IA Claude 4.5 · clasifica notificaciones AAPP / LexNET / Licitaciones / facturas",
    color: "#DC2626",
    route: "/legal",
    Icon: ListChecks,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
    deprecated: true,
  },
  {
    key: "fin_cuentas_pagar",
    title: "Cuentas a pagar (3-bandas)",
    description: "Cotejo factura ↔ pedido ↔ albarán · 4009/4109",
    color: "#1E5BCC",
    route: "/financiero/cuentas-pagar",
    Icon: Receipt,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "fin_cuentas_cobrar",
    title: "Cuentas a cobrar (AR)",
    description: "Disparado por certificación aprobada · seguimiento cobros",
    color: "#0F8A5F",
    route: "/financiero/cuentas-cobrar",
    Icon: BadgeDollarSign,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "fin_tesoreria",
    title: "Tesorería",
    description: "Saldos diarios · conciliación bancaria ±3 días",
    color: "#127372",
    route: "/financiero/tesoreria",
    Icon: Activity,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "facturcal",
    title: "FACTURCAL · Consolidado grupo",
    description: "Pagos, cobros y tesorería · visión consolidada del grupo",
    color: "#7C3AED",
    route: "/financiero/facturcal",
    Icon: Building2,
    category: "_hidden",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "onboarding",
    title: "Puesta en marcha",
    description: "Asistente guiado: empresa, banco, series de facturación y certificado digital",
    color: "#0F8A5F",
    route: "/puesta-en-marcha",
    Icon: Sparkles,
    category: "personas",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "pagos",
    title: "Pagos y Cobros",
    description: "Cobra facturas por enlace (tarjeta · Google Pay · Apple Pay) y paga a proveedores por remesa SEPA",
    color: "#0E7490",
    route: "/pagos",
    Icon: BadgeDollarSign,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "cartera",
    title: "Mi Cartera",
    description: "Tus tarjetas de empresa y fidelización estilo Google Wallet · códigos QR/barras para enseñar en caja",
    color: "#0D9488",
    route: "/cartera",
    Icon: Wallet,
    category: "mis_cosas",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "tarjetas",
    title: "Tarjetas de Empresa",
    description: "Tarjetas corporativas y de combustible · gastos con ticket + OCR IA, obra/vehículo y contabilidad automática",
    color: "#0F8A5F",
    route: "/tarjetas",
    Icon: CreditCard,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "sede_reglas",
    title: "Reglas de Sede Electrónica",
    description: "Movido dentro de Notificaciones Administrativas (DEHú) · pestaña Reglas",
    color: "#7C3AED",
    route: "/sede-reglas",
    Icon: Scale,
    category: "_hidden",  // WA0270 · integrado como pestaña en Notificaciones Administrativas
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "chat",
    title: "Chat interno",
    description: "Mensajes directos entre usuarios de la plataforma",
    color: "#1E5BCC",
    route: "/chat",
    Icon: MessagesSquare,
    category: "personas",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "cfo",
    title: "Panel CFO",
    description: "Vista ejecutiva: tesorería, facturación, morosidad, resultado y fiscalidad en una sola pantalla",
    color: "#0F1A3C",
    route: "/financiero/cfo",
    Icon: TrendingUp,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "morosidad",
    title: "Morosidad y Reclamaciones",
    description: "Aging de facturas vencidas · secuencia automática de reclamación (amistoso → formal → intereses Ley 3/2004) · dosier judicial PDF",
    color: "#B43A4E",
    route: "/financiero/morosidad",
    Icon: AlarmClock,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "financiero_ops",
    title: "Cierre · Inmovilizado · Contratos · Avales",
    description: "Operaciones financieras avanzadas · DSO/PMP · semáforo contratos",
    color: "#C9892E",
    route: "/financiero/operaciones",
    Icon: HistoryIcon,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "flota",
    title: "Flota · Anexo de vehículo",
    description: "Vehículos · asignaciones · anexo firmable · tarjeta de combustible · entregas/devoluciones",
    color: "#1E8FA5",
    route: "/rrhh/flota",
    Icon: UsersRound,
    category: "administracion",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "plantilla",
    title: "Contratación de Personal",
    description: "Dimensionamiento por obra · anuncios IA con Claude Sonnet 4.5 · propuestas de contratación",
    color: "#9E5BCC",
    route: "/rrhh/plantilla",
    Icon: UsersRound,
    category: "personas",
    span: "md:col-span-1 md:row-span-1",
  },
  // WA0224 · Fase A · "Roles operativos · CAE" retirado del menú
  // (control de accesos e informes de reuniones semanales ya cubiertos en Gestión de Obra).
  {
    key: "microcompras",
    title: "Microcompras en obra",
    description: "Encargado · pedidos rápidos · validación auto · albarán · 3-bandas",
    color: "#C2410C",
    route: "/microcompras",
    Icon: ShoppingCart,
    category: "_hidden",
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "produccion_subcontratas",
    title: "Producción subcontratas",
    description: "Control semanal · precertificación automática · 95% validación previa",
    color: "#0E7490",
    route: "/produccion-subcontratas",
    Icon: HardHat,
    category: "_hidden",  // WA0229 · Pausado hasta que aporte información útil
    deprecated: true,
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "legal_config",
    title: "Configuración legal/fiscal",
    description: "IVA · ISP · umbrales · sancionador · auditoría · solo admin",
    color: "#6D28D9",
    route: "/admin/legal-config",
    Icon: ScrollText,
    category: "juridico",
    span: "md:col-span-1 md:row-span-1",
  },
  // WA0221 · retirado del menú: "Gerencia · Incentivos + Desempeño" (a replantear como módulo separado).
  {
    key: "aprobacion_facturas",
    title: "Aprobación automática de facturas",
    description: "Material (3-bandas) · Subcontrata (contrato + certificación) · Retención legalización",
    color: "#0EA5E9",
    route: "/aprobacion-facturas",
    Icon: Receipt,
    category: "financiero",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "email_inbox",
    title: "Correo Electrónico",
    description: "Bandeja IMAP (proveedor de correo de la empresa) · IA Claude 4.5 clasifica AAPP / LexNET / facturas. NO es el módulo LEGAL (que está aparte).",
    color: "#127372",
    route: "/correo",
    Icon: Mail,
    category: "correo",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "notificaciones",
    title: "Comunicación Interna",
    description: "Comunicados internos con plantillas, adjuntos y firma",
    color: "#A03060",
    route: "/comunicacion",
    Icon: Megaphone,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "clientes",
    title: "Portal de Clientes",
    description: "Acceso público compartible por obra para clientes",
    color: "#1E8FA5",
    route: "/clientes",
    Icon: Users2,
    category: "comercial_dept",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "admin",
    title: "Administración",
    description: "Usuarios, roles y ajustes",
    color: "#475569",
    route: "/admin",
    Icon: Settings2,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "sala_reuniones",
    title: "Videos · Sala de Reuniones",
    description: "Videoconferencias HD por obra · actas IA",
    color: "#D85A1F",
    route: "/sala-reuniones",
    Icon: Video,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
  },
  // WA0221 · retirado del menú: "Audit log" (registro técnico interno).
  // Los logs se siguen escribiendo en BD para compliance/debug, sólo se oculta la ruta pública.
  {
    key: "calendario",
    title: "Calendario",
    description: "Tareas asignadas, plazos y eventos por usuario",
    color: "#0E9488",
    route: "/calendario",
    Icon: CalendarDays,
    category: "personas", // WA0224 · fusionado desde "transversal"
    span: "md:col-span-1 md:row-span-1",
  },
];

// Legacy alias: para los componentes que aún hacen findModule("avales") o
// findModule("garantias"), devolvemos el módulo unificado conservando la key
// histórica para que los lookups por key directa sigan funcionando.
const LEGACY_TO_NEW = { avales: "avales_garantias", garantias: "avales_garantias", compras: "adquisiciones" };

export const findModule = (key) => {
  const direct = MODULES.find((m) => m.key === key);
  if (direct) return direct;
  // Legacy alias: componentes que aún piden "avales", "garantias" o "compras"
  // reciben el módulo unificado para que sus referencias (color, title) sigan
  // funcionando sin romper.
  const mapped = LEGACY_TO_NEW[key];
  if (mapped) return MODULES.find((m) => m.key === mapped);
  return undefined;
};

export const findModuleLegacy = (key) => findModule(key);

// Útil para Dashboard y Layout: módulos agrupados por categoría preservando
// el orden declarado en MODULES.
export const modulesByCategory = () => {
  const out = {};
  for (const cat of CATEGORIES) out[cat.key] = [];
  for (const m of MODULES) {
    if (m.category && out[m.category]) out[m.category].push(m);
  }
  return out;
};
